import { CommentActionType } from "../MedicalRequest/Enum/CommentActionType";

class IndividualMessageNote {
    public Id: string;
    public IndividualMessageId?: string;
    public ContactId?: string;
    public ContactFacetId?: string;
    public Note: string;
    public DateCreated: string;
    public ActionResultLookupId?: string;
    public ActionType?: CommentActionType;
}

class IndividualMessagesLinkedItem {
    public LinkId: number;
    public IndividualMessageId: string;
    public Source: number;
    public PatientContactId: string;
    public EncounterId: string;
    public LabFillerId: string;
    public DocumentId: string;
    public CreationDate: Date;
    public EmployeeId: string;
    public RecallId: string;
}

export { IndividualMessageNote, IndividualMessagesLinkedItem };
